// ── seasonWrap (pure) ────────────────────────────────────────────────────────
// The season, told back to you: every episode as a bar (your reels) with the mood you
// picked beneath it, the standout, and the one line that sums it up. Fed by your own
// ratings and reactions; nothing here is anyone else's. Tested in seasonWrap.test.js.
export function seasonStats({ episodes = [], ratings = {}, moods = {}, season }) {
  const eps = (episodes || []).filter(e => e && e.episode_number > 0).sort((a, b) => a.episode_number - b.episode_number)
  const bars = eps.map(e => {
    const k = `${season}-${e.episode_number}`
    const r = ratings[k]
    return { ep: e.episode_number, name: e.name || `Episode ${e.episode_number}`, rating: Number.isFinite(Number(r)) && r != null ? Number(r) : null, mood: moods[k] || null }
  })
  const rated = bars.filter(b => b.rating != null)
  const avg = rated.length ? Math.round((rated.reduce((a, b) => a + b.rating, 0) / rated.length) * 10) / 10 : null
  const standout = rated.length ? rated.reduce((best, b) => (b.rating > best.rating ? b : best), rated[0]) : null
  const moodCounts = {}
  for (const b of bars) if (b.mood) moodCounts[b.mood] = (moodCounts[b.mood] || 0) + 1
  const topMood = Object.entries(moodCounts).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0]?.[0] || null
  return { bars, rated: rated.length, avg, standout, moodCounts, topMood, total: bars.length }
}

// "8 episodes · 3.6 reels · mostly 🤯" with the pieces you actually have.
export function wrapLine(st) {
  if (!st || !st.total) return ''
  const parts = [`${st.total} episode${st.total === 1 ? '' : 's'}`]
  if (st.avg != null) parts.push(`${st.avg} reels`)
  if (st.topMood) parts.push(`mostly ${st.topMood}`)
  return parts.join(' · ')
}

// What the sheet says at the top. Honest about thin data: no ratings, no verdict.
export function wrapHeadline(st) {
  if (!st || !st.total) return 'Your season.'
  if (st.avg == null && !st.topMood) return 'Your season, unrated.'
  if (st.avg != null && st.avg >= 4.5) return 'A season you loved.'
  if (st.avg != null && st.avg >= 3.5) return 'A season that held you.'
  if (st.avg != null && st.avg < 2.5) return 'A season you got through.'
  return 'Your season, in moods.'
}
